import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';

const columns = [{
  Header: 'Date',
  id: 'date',
  accessor: row => moment(row.date).format('MMMM Do, YYYY'),
}, {
  Header: 'Pharmacy',
  accessor: 'pharmacy_name',
}, {
  Header: 'Link',
  accessor: 'id',
  Cell: ({ value }) => <Link to={`/corporate/scripts/requests/${value}`}>View Script</Link>,
  includeInExport: false
}];


const StaleScriptsTable = ({ scripts, includeExport }) => (
  <Table
    actions={includeExport && (
      <div className='u-paddingTop10'>
        <ColumnExportButton
          filename='Vetcove_Stale_Scripts.csv'
          data={scripts}
          columns={columns}
        >
          Download
        </ColumnExportButton>
      </div>
    )}
    size='small'
    columns={columns}
    data={scripts}
    pageSize={scripts.length || 10}
    showPagination={false}
  />
);

StaleScriptsTable.propTypes = {
  scripts: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default StaleScriptsTable;
